<div data-testid="zone-tile">
    <div class="zone__top border-zone">
        <floating-subtitle class="zone__name zone__name--tile font-21"
            [text]="zones.setTileName(tile.params.txtId, 768)">
        </floating-subtitle>
    </div>

    <div class="zone__status zone__status-background gradient-zone" data-testid="animation"></div>

    <div class="zone__content">
        <div class="zone__content-icon">
            <icon [iconName]="'sun-cloud'"
                data-testid="tile-icon-sun-cloud"
                [iconSize]="views.isMobileView() ? 40 : 50"
                [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'sun-cloud'"
                data-testid="tile-icon-sun-cloud-mobile"
                [iconSize]="views.isMobileView() ? 40 : 50"
                [className]="'zone__icon zone__icon--dark fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__current-temp" data-testid="tile-value">
            {{ tile.params.value | format:7 }}
        </div>
    </div>

    <div class="zone__footer zone__footer--temp bg-style">
        <div class="zone__icons zone__icons--temp">
            <div class="zone__footer-icon zone__footer-icon--battery-alarm"
                 *ngIf="tile.params.batteryLevel !== null"
                 [ngClass]="{ 'bg-error': tile.params.batteryLevel <=20 }">
                <div class="zone__img-wrapper zone__img-wrapper--battery border-light">
                    <img ngSrc="/assets/img/zone_icons/battery_white.svg"
                         width="15" height="15" alt="" />
                    <p class="zone__value zone__value--battery font-15" data-testid="battery-level">
                       {{ tile.params.batteryLevel | format:8 }}
                    </p>
                </div>
            </div>
            <div class="zone__footer-icon "
                *ngIf="tile.params.signalStrength !== null">
                <div class="zone__img-wrapper border-light">
                    <img class="dropdown-list__signal" data-testid="signal-icon"
                        ngSrc="{{ zones.signalIcon(tile.params, 'white')}}"
                        width="19" height="19" alt="" />
                </div>
            </div>
            <div class="zone__footer-icon zone__footer-icon--temp"
                *ngIf="tile.params.signalStrength === null
                    && tile.params.batteryLevel === null">
                <div class="zone__img-wrapper zone__img-wrapper--big border-light">
                    <img ngSrc="/assets/img/zone_icons/temp_wireless.svg"
                        data-testid="wired-icon" width="25" height="25" alt="" />
                </div>
            </div>
        </div>
    </div>
</div>
